import { useMemo } from 'react';
import { documentFormFields } from '../pages/documents/document.config';
import { documentApi } from '../api/accountsApi';
import ExcelUploadManager from './excelUpload/ExcelUploadManager';

const DocumentExcelUpload = () => {
  const moduleConfig = useMemo(
    () => ({
      fieldConfig: documentFormFields,
      title: 'Documents',
      saveApi:
        documentApi.batchCreate ||
        (async (rows: any[]) => {
          for (const row of rows) {
            await documentApi.create(row);
          }
          return { failedRows: [] };
        }),
    }),
    []
  );

  return (
    <ExcelUploadManager
      moduleTitle={moduleConfig.title}
      fieldConfig={moduleConfig.fieldConfig}
      saveApi={moduleConfig.saveApi}
    />
  );
};

export default DocumentExcelUpload;
